import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { get } from 'lodash'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import { makeAuthenticatedApi } from '../api'
import { themeColors } from '../styles/theme'

import {
  loadSwapDetail,
  unloadSwapDetail,
  acceptSwap,
  rejectSwap,
  cancelSwap,
  swapAddItemProponente,
  swapAddItemDestinatario,
  swapRemoveItemProponente,
  swapRemoveItemDestinatario,
  swapSetMoneyProponente,
  swapSetMoneyDestinatario,
  resetSwap,
  updateSwap,
  feedbackSwap,
  archiveSwap,
  reverseSwap,
} from '../actions'
import { getSwapDetail, getIsSwapReversed } from '../selectors'
import {
  isProponente,
  isDestinatario,
  getSwapForYou,
  getSwapForMe,
} from '../utils'

import Spinner from '../common/Spinner'
import NotFound from '../common/NotFound'
import ErrorPage from '../common/ErrorPage'
import Swap from '../common/Swap'
import RejectSwapForm from '../common/Swap/RejectSwapForm'
import FeedbackModal from '../common/Swap/FeedbackModal'
import MessageModal from '../common/Swap/MessageModal'

class SwapDetail extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      acceptDialogOpen: false,
      rejectDialogOpen: false,
      cancelDialogOpen: false,
      feedbackModalOpen: false,
      messageModalOpen: false,
      archiveModalOpen: false,
      reverseSwapModalOpen: false,
      editSwap: false,
    }
  }

  componentDidMount() {
    this.props.loadSwapDetail(this.props.match.params.id)
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.match.params.id !== nextProps.match.params.id &&
      !get(nextProps.location, 'state.preventSwapReload')
    ) {
      this.props.unloadSwapDetail()
      this.props.loadSwapDetail(nextProps.match.params.id)
    }

    // Swap reversed server side! Reload url \w new id but prevent to reload
    if (
      this.props.swap &&
      nextProps.swap &&
      this.props.swap.id !== nextProps.swap.id
    ) {
      this.props.history.replace(`/swap/${nextProps.swap.id}`, {
        preventSwapReload: true,
      })
    }
  }

  componentWillUnmount() {
    this.props.unloadSwapDetail()
  }

  toggleAcceptDialogOpen = () => {
    this.setState(state => ({ acceptDialogOpen: !state.acceptDialogOpen }))
  }

  toggleRejectDialogOpen = () => {
    this.setState(state => ({ rejectDialogOpen: !state.rejectDialogOpen }))
  }

  toggleCancelDialogOpen = () => {
    this.setState(state => ({ cancelDialogOpen: !state.cancelDialogOpen }))
  }

  toggleEditSwap = () => {
    this.setState(state => ({ editSwap: !state.editSwap }))
  }

  toggleFeedbackModalOpen = () => {
    this.setState(state => ({ feedbackModalOpen: !state.feedbackModalOpen }))
  }

  toggleArchiveDialogOpen = () => {
    this.setState(state => ({ archiveModalOpen: !state.archiveModalOpen }))
  }

  toggleMessageModalOpen = () => {
    this.setState(state => ({ messageModalOpen: !state.messageModalOpen }))
  }

  toggleReverseSwapModalOpen = () => {
    this.setState(state => ({
      reverseSwapModalOpen: !state.reverseSwapModalOpen,
    }))
  }

  render() {
    const { user, swap, loading, error } = this.props

    if (!swap && loading) {
      return <Spinner centered />
    }

    if (!swap && error) {
      return <ErrorPage error={error} />
    }

    // Swap not realted to me...
    if (swap && !isDestinatario(swap, user) && !isProponente(swap, user)) {
      return <NotFound />
    }

    return (
      <div className="padding">
        {swap && this.renderSwap()}
      </div>
    )
  }

  renderSwap() {
    const {
      user,
      swap,
      isSwapReversed,
      updating,
      performingAction,
      swapAddItemProponente,
      swapAddItemDestinatario,
      swapRemoveItemProponente,
      swapRemoveItemDestinatario,
      swapSetMoneyProponente,
      swapSetMoneyDestinatario,
    } = this.props

    const swapForYou = getSwapForYou(swap, user)
    const swapForMe = getSwapForMe(swap, user)

    return (
      <div>
        <Swap
          swap={swap}
          user={user}
          editable={this.state.editSwap}
          performingAction={performingAction || updating}
          setMoneyProponente={swapSetMoneyProponente}
          setMoneyDestinatario={swapSetMoneyDestinatario}
          addItemDestinatario={swapAddItemDestinatario}
          addItemProponente={swapAddItemProponente}
          removeItemDestinatario={swapRemoveItemDestinatario}
          removeItemProponente={swapRemoveItemProponente}
          onEditClick={() => {
            if (swap.destinatario.id === user.id) {
              this.toggleReverseSwapModalOpen()
            } else {
              this.toggleEditSwap()
            }
          }}
          onUndoEditClick={() => {
            this.toggleEditSwap()
            this.props.resetSwap()
          }}
          onSwap={() => {
            this.toggleEditSwap()
            this.props.updateSwap(swap, isSwapReversed)
          }}
          onArchiveClick={this.toggleArchiveDialogOpen}
          onCancelClick={this.toggleCancelDialogOpen}
          onAcceptClick={this.toggleAcceptDialogOpen}
          onRejectClick={this.toggleRejectDialogOpen}
          onFeedbackClick={this.toggleFeedbackModalOpen}
          onMessageClick={this.toggleMessageModalOpen}
        />
        <Dialog
          title="Accetta proposta"
          titleStyle={{ backgroundColor: themeColors.lightBackground }}
          modal={false}
          open={this.state.acceptDialogOpen}
          onRequestClose={this.toggleAcceptDialogOpen}
          actions={[
            <FlatButton
              label="Annulla"
              primary={true}
              onClick={this.toggleAcceptDialogOpen}
            />,
            <FlatButton
              label="Ok"
              primary={true}
              keyboardFocused={true}
              onClick={() => {
                this.toggleAcceptDialogOpen()
                this.props.acceptSwap(swap.id, swap.updated_at)
              }}
            />,
          ]}
          autoScrollBodyContent={true}>
          <p>Confermi di accetare la proposta di scambio?</p>
        </Dialog>
        <Dialog
          title="Rifiuta proposta"
          titleStyle={{ backgroundColor: themeColors.lightBackground }}
          modal={false}
          open={this.state.rejectDialogOpen}
          onRequestClose={this.toggleRejectDialogOpen}
          autoScrollBodyContent={true}>
          <RejectSwapForm
            toggleOpen={this.toggleRejectDialogOpen}
            onSubmit={({ reason }) => {
              this.toggleRejectDialogOpen()
              this.props.rejectSwap(swap.id, reason, swap.updated_at)
            }}
          />
        </Dialog>
        <Dialog
          title="Annullamento proposta"
          titleStyle={{ backgroundColor: themeColors.lightBackground }}
          modal={false}
          open={this.state.cancelDialogOpen}
          onRequestClose={this.toggleCancelDialogOpen}
          actions={[
            <FlatButton
              label="Annulla"
              primary={true}
              onClick={this.toggleCancelDialogOpen}
            />,
            <FlatButton
              label="Ok"
              primary={true}
              keyboardFocused={true}
              onClick={() => {
                this.toggleCancelDialogOpen()
                this.props.cancelSwap(swap.id)
              }}
            />,
          ]}
          autoScrollBodyContent={true}>
          <p>Confermi l'annullamento della proposta?</p>
        </Dialog>
        <Dialog
          title="Archivia proposta"
          titleStyle={{ backgroundColor: themeColors.lightBackground }}
          modal={false}
          open={this.state.archiveModalOpen}
          onRequestClose={this.toggleArchiveDialogOpen}
          actions={[
            <FlatButton
              label="Annulla"
              primary={true}
              onClick={this.toggleArchiveDialogOpen}
            />,
            <FlatButton
              label="Ok"
              primary={true}
              keyboardFocused={false}
              onClick={() => {
                this.toggleArchiveDialogOpen()
                this.props.archiveSwap(swap.id, swapForMe.user.id)
              }}
            />,
          ]}
          autoScrollBodyContent={true}>
          <p>Confermi l'archivio della proposta?</p>
        </Dialog>
        <FeedbackModal
          open={this.state.feedbackModalOpen}
          onRequestClose={this.toggleFeedbackModalOpen}
          onFeedback={(rating, reason) => {
            this.props.feedbackSwap(swap.id, swapForYou.user.id, rating, reason)
          }}
        />
        <Dialog
          title="Modifica proposta"
          titleStyle={{ backgroundColor: themeColors.lightBackground }}
          modal={false}
          open={this.state.reverseSwapModalOpen}
          onRequestClose={this.toggleReverseSwapModalOpen}
          actions={[
            <FlatButton
              label="Annulla"
              primary={true}
              onClick={this.toggleReverseSwapModalOpen}
            />,
            <FlatButton
              label="Ok"
              primary={true}
              keyboardFocused={true}
              onClick={() => {
                this.toggleReverseSwapModalOpen()
                this.props.reverseSwap()
                this.toggleEditSwap()
              }}
            />,
          ]}
          autoScrollBodyContent={true}>
          <p>
            Attenzione: la proposta corrente verrà rifiutata e ne verrà creata una con gli stessi oggetti, che potrai modificare per fare una controproposta
          </p>
        </Dialog>
        <MessageModal
          user={swapForYou.user}
          open={this.state.messageModalOpen}
          onRequestClose={this.toggleMessageModalOpen}
          onSubmit={({ text }) => {
            return this.props.api.sendMessage(swapForYou.user.id, text)
          }}
          onSubmitSuccess={() => {
            this.toggleMessageModalOpen()
          }}
        />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
  api: makeAuthenticatedApi(state), // <--- Curried authentictation
  swap: getSwapDetail(state),
  isSwapReversed: getIsSwapReversed(state),
  performingAction: state.swapDetail.performingAction,
  updating: state.swapDetail.updating,
  loading: state.swapDetail.loading,
  error: state.swapDetail.error,
})

export default connect(mapStateToProps, {
  loadSwapDetail,
  unloadSwapDetail,
  acceptSwap,
  rejectSwap,
  cancelSwap,
  swapAddItemProponente,
  swapAddItemDestinatario,
  swapRemoveItemProponente,
  swapRemoveItemDestinatario,
  swapSetMoneyProponente,
  swapSetMoneyDestinatario,
  resetSwap,
  updateSwap,
  feedbackSwap,
  archiveSwap,
  reverseSwap,
})(SwapDetail)



// WEBPACK FOOTER //
// ./src/pages/SwapDetail.js